import { createScopedLogger } from "@@common";
import { IToastService } from "../../common/hooks/useToastService";
import { NotifySeverity } from "../../ExpressionsModule/Models/UserInterfaces/NotifyExpression";

const logger = createScopedLogger("NotifyService");

export class NotifyService {
  static readonly KEY = "NotifyService";

  private _toastService: IToastService | null = null;

  setToastService(svc: IToastService): void {
    this._toastService = svc;
  }

  notify(message: string, severity: NotifySeverity = NotifySeverity.Info): void {
    if (!this._toastService) {
      logger.warn("ToastService not set yet.");
      return;
    }

    if (severity === NotifySeverity.Success) {
      this._toastService.success(message);
    } else if (severity === NotifySeverity.Error) {
      this._toastService.error(message);
    } else {
      this._toastService.info(message);
    }
  }
}
